 <!-- 算法发车单列表 -->
<template>
    <paper id="agingProduct">
        <m-pane
            ref="tablePage"
            :config="config"
            :loading="loading"
            :pageTotal="pageTotal"
            :searchTotalTitle="searchTotalTitle"
            :totalData="totalData"
            :currentPage="searchParams.pageNo"
            pageID="NewTrainList"
            searchId="NewTrainListQuery"
            @btnClick="handleClickCell"
            @pageChange="handlePageChange"
            @searchChange="handleSearch"
            @selectChange="handleSelect"
            @sizeChange="handleSizeChange"
            @arrange-btn="handleArrangeBtn"
            @edit-btn="handleEditBtn"
            @row-db-click="rowDBClick"
            @low-loading-approval-btn="lowLoadingApproval"
        >
            <div slot="table-module-btn" class="table-module-btn">
                <reportExport
                    #default="{ submit }"
                    reportCode="REPORT_ALGORITHM_DISPATCH_CONFIG"
                >
                    <el-tooltip content="导出" effect="dark" placement="bottom">
                        <span v-has="''" class="mgl-5 bigData-btn-export">
                            <el-button
                                icon="icon-daochu"
                                size="mini"
                                @click="handleExport(submit)"
                            ></el-button>
                        </span>
                    </el-tooltip>
                </reportExport>
            </div>
            <div slot="page-module-btn">
                <el-button
                    v-has="''"
                    type="primary"
                    class="bigData-btn-adopt"
                    @click="handleAdopt"
                    >采 纳</el-button
                >
                <el-button
                    v-has="''"
                    type="primary"
                    @click="handleToAdjust"
                    >可视化调整</el-button
                >
                <el-button
                    v-has="''"
                    type="primary"
                    class="bigData-btn-invalidate"
                    @click="handleInvalidate"
                    >作 废</el-button
                >
            </div>
        </m-pane>
        <car-scheduling-dialog
            v-if="isArrangeSubmitVisi"
            ref="carScheduling"
            :RwCarVisiable.sync="isArrangeSubmitVisi"
            :inOutType="currInOutType"
            :taskDataList="taskDataList"
            :dispatchSaveFlag="dispatchSaveFlag"
            :checkDispatch="checkDispatch"
            :dataLists="rowTrainData"
            label-task="right"
            @AdmittOk="handleArrangeSubmitOk"
        >
        </car-scheduling-dialog>

       <!-- 串点详情弹窗 -->
        <stationDetailDialog
        :detailVisible.sync="stationDetailVisible"
        :trainNum="stationDetailTrainNum"
       />
    </paper>
</template>
<script>
import MPane from '@/components/otpPanel';
import config from './config.js';
import Paper from '@/components/core/paper/Paper';
import CarSchedulingDialog from '@otp/components/dialog/carSchedulingDialog';
import * as api from '@otp/api/dispatchPlan/newTrainList';
import { showCopiableMessage, copyText, formatParams } from './utils';
import reportExport from '@/components/lots/reportExportPlugin';
import { mapState } from 'vuex';
import bigDataLog from '@/utils/bigDataLog';

export default {
    name: 'newTrainList',
    components: { MPane, Paper, CarSchedulingDialog, reportExport, stationDetailDialog: () => import('@otp/components/dialog/stationDetail/stationDetail') },
    data () {
        return {
            config: config,
            selectedData: [],
            isFirstSearch: true,
            taskDataList: [], // 点击排车时，该车次包含的运输单
            totalData: [],
            loading: false,
            searchTotalTitle: config.searchTotalTitle,
            searchParams: {
                pageSize: 10,
                pageNo: 1,
                schemeType: 'OP',
                orderBy: 'createTime', // 排序
                orderByType: 'desc'
            },
            pageTotal: 0,

            rowsToArrange: [], // 待排车的行
            isArrangeSubmitVisi: false, // 排车弹窗是否展示
            dispatchSaveFlag: true, // 行排车点击标识，true为算法排车，false为线路排车
            checkDispatch: true, // 开启排车承运商限制
            stationDetailVisible: false, // 串点详情弹窗
            stationDetailTrainNum: '', // 点击详情时发车单号
            rowTrainData: {},
            siteCodeList: []
        };
    },
    computed: {
        // "订单大类", 'IN' 为入库, 字典: IN_OUT_TYPE
        currInOutType () {
            return this.rowsToArrange.length > 0 ? this.rowsToArrange[0].inOutType : 'IN';
        },
        ...mapState({ user: state => state.user })
    },
    methods: {
        // 接口获取数据
        getList () {
            this.loading = true;
            api.search(this.searchParams).then((res) => {
                if (res && +res.code === 0) {
                    this.totalData = res.data.list.map(item => {
                        item.hiddenEvent = [];
                        // 只有待调车, 显示"排车"按钮
                        if (+item.dispatchStatus !== 6) {
                            item.hiddenEvent.push('arrange');
                        }
                        // 待到车|待装车|待发车, 显示"编辑"按钮
                        if (![10, 20, 30].includes(+item.dispatchStatus)) {
                            item.hiddenEvent.push('edit');
                        }
                        item.dispatchStatus = item.dispatchStatus + '';
                        item.volumeRates = item.volumeRate ? Math.round((item.volumeRate + Number.EPSILON) * 10000) / 100 + '%' : '';
                        item.vehicleCardAndEquipmentName = (item.vehicleCard || '') + ' / ' + (item.actualEquipmentName || '');
                        item.driverAndDriverContactWay = (item.driver || '') + ' / ' + (item.driverContactWay || '');
                        item.stationDetailBtn = '站点详情';
                        return item;
                    });
                    this.pageTotal = res.data.totalCount;
                }
            })
                .catch(() => {})
                .finally(() => {
                    this.loading = false;
                    this.isFirstSearch = false;
                });
        },
        // 点击查询
        handleSearch (params) {
            const param = formatParams(params);
            this.searchParams = {
                ...this.searchParams,
                ...param,
                pageNo: 1
            };
            param && this.getList();
        },
        /// 表格选择变化
        handleSelect (rows) {
            this.selectedData = rows;
        },
        /// 分页器页数变化
        handlePageChange (pageNo) {
            this.searchParams.pageNo = pageNo;
            this.getList();
        },
        /// 分页器页数大小变化
        handleSizeChange (pageSize) {
            this.searchParams.pageSize = pageSize;
            this.searchParams.pageNo = 1;
            this.getList();
        },
        /// 点击单元格
        handleClickCell (val, index, row, prop) {
            if (prop === 'stationDetailBtn') {
                this.stationDetailTrainNum = row && row.trainNum;
                this.stationDetailVisible = true;
            } else {
                copyText(this.$message, val);
            }
        },
        // 双击
        rowDBClick (row) {
            this.handleToDetail(row);
        },
        /// 进入详情页面
        handleToDetail (rowData) {
            this.$router.push({
                query: { rowData: rowData },
                path: '/dispatch-Manage/new-train-detail'
            });
        },
        // 采纳
        handleAdopt () {
            if (!this.selectedData.length) {
                return this.$message.warning('至少选择一条数据！');
            }
            if (this.selectedData.some(v => ![2, 3].includes(+v.dispatchStatus))) {
                return this.$message.warning('只有状态为待审核或审核失败才能操作采纳');
            }
            api.adoptApi({ lineDetailIds: this.selectedData.map(v => v.id) }).then((res) => {
                if (res && +res.code === 0) {
                    if (res.data) {
                        this.$message.error(res.data);
                    } else {
                        this.$message.success('采纳成功');
                        this.getList();
                    }
                }
            });
        },
        // 进入可视化调整页面
        handleToAdjust () {
            if (!this.selectedData.length) {
                return this.$message.warning('至少选择一条数据！');
            }
            bigDataLog.sendDetailMessageByKey('bigData-btn-adjust');
            const ids = this.selectedData.map(r => r.id);
            this.$router.push({
                query: { lineDetailIds: ids.join(',') },
                path: '/dispatch-Manage/train-list-adjusts'
            });
        },
        // 作废
        handleInvalidate () {
            if (!this.selectedData.length) {
                return this.$message.warning('至少选择一条数据！');
            }
            if (this.selectedData.some(v => +v.dispatchStatus >= 10)) {
                return this.$message.warning('只有状态为待到车之前才可以作废');
            }
            api.cancelTrainNum({ lineDetailIds: this.selectedData.map(v => v.id) }).then((res) => {
                if (res && +res.code === 0) {
                    this.$message.success('作废成功');
                    this.getList();
                }
            });
        },
        // 导出
        handleExport (submit) {
            // 第一次点导出时触发查询函数，之后的导出以前一次的查询条件为准
            this.isFirstSearch && this.$refs.tablePage.$refs.searchList.onSearchChange();
            const params = {
                ...this.searchParams,
                schemeType: 'OP'
            };
            if (!params.startTime) {
                return this.$message.warning('时间必填！');
            }
            submit(params);
            this.isFirstSearch = false;
        },
        // 点击编辑
        async  handleEditBtn (rowData) {
            this.rowTrainData = rowData;
            this.dispatchNo = rowData.dispatchNo;
            this.version = rowData.version;
            const res = await api.lineDetailWithOrder({ trainNum: rowData.trainNum, schemeType: 'OP' });
            this.taskDataList = res.data.list || [];
            this.isArrangeSubmitVisi = true;
            bigDataLog.sendDetailMessageByKey('bigData-btn-edit');
        },
        lowLoadingApproval(data) {
            const optId = data.otpId;
            if (!optId) {
                return this.$message.warning('暂未生成审批流程');
            }
            window.open(`/iframe/tms-vehicle-loading-rate-iflow.html?iflowId=${optId}`);
        },
        // 草稿、审批中状态不允许操作
        isSpecialReviewStatu(rowData) {
            if (['00', '10'].includes(rowData.reviewStatus)) {
                this.$message.warning('该发车单处于草稿或审批中，不允许操作。请在配载调整页面的【低装载审批详情】中先作废流程再进行操作');
                return false;
            }
            return true;
        },
        // 点击排车按钮
        handleArrangeBtn (row) {
            if (!this.isSpecialReviewStatu(row)) return;
            this.rowsToArrange = [row];
            this.rowTrainData = {};
            api.lineDetailWithOrder({ trainNum: row.trainNum, schemeType: 'OP' }).then(res => {
                if (res && +res.code === 0) {
                    this.taskDataList = res.data.list;
                    this.isArrangeSubmitVisi = true;
                    this.$nextTick(() => {
                        this.$refs.carScheduling.$refs.carrierName.show();
                    });
                }
            });
            bigDataLog.sendDetailMessageByKey('bigData-btn-arrange');
        },
        // 处理排车弹框确认按钮
        handleArrangeSubmitOk (data) {
            // 待到车|待装车|待发车, 调"编辑"接口
            if ([10, 20, 30].includes(+this.rowTrainData.dispatchStatus)) { // 编辑
                data.data['dispatchNo'] = this.dispatchNo;
                data.data['version'] = this.version;
                if (data.state === true) {
                    api.getDispathOrderPreservation(data.data, this.dispatchNo, this.version).then(res => {
                        if (res && res.code === '0') {
                            if (res.msg === 'Success') {
                                this.$message.success('保存成功');
                            } else {
                                this.$message({
                                    showClose: true,
                                    type: 'success',
                                    duration: 5000,
                                    message: `${res.msg}`
                                });
                            }
                            this.isArrangeSubmitVisi = false;
                            this.getList();
                        } else {
                            this.isArrangeSubmitVisi = true;
                        }
                    }).catch(() => {
                        this.isArrangeSubmitVisi = true;
                    });
                } else {
                    return false;
                }
            } else { // 排车
                data = Object.assign({ preDispatchType: '2', trainNum: this.rowsToArrange[0].trainNum }, data.data);
                api.dispatchSave(data).then(res => {
                    this.$refs.carScheduling.saveLoading = false;
                    if (res && +res.code === 0) {
                        if (res.data && res.data.includes('装载率低于')) {
                            // 低载率卡控弹窗

                            this.$confirm(res.data, '提示', {
                                confirmButtonText: '发起审批',
                                cancelButtonText: '取消',
                                customClass: 'low-loading-rate-class',
                                beforeClose: (action, instance, done) => {
                                    if (action === 'confirm') {
                                        instance.confirmButtonLoading = true;
                                        instance.confirmButtonText = '执行中...';
                                        api.createIflow({
                                            dispatchNo: this.rowsToArrange[0].trainNum,
                                            carrierName: data.carrierName,
                                            vehicleCard: data.vehicleCard || '',
                                            equipmentName: data.equipmentName,
                                            equipmentType: data.equipmentType })
                                            .then(res => {
                                                if (res && +res.code === 0) {
                                                    if (res.data) {
                                                        window.open(`/iframe/tms-vehicle-loading-rate-iflow.html?iflowId=${res.data}`);
                                                    }
                                                    done();
                                                }
                                            })
                                            .finally(() => {
                                                instance.confirmButtonLoading = false;
                                                this.isArrangeSubmitVisi = false;
                                                done();
                                            });
                                    } else {
                                        done();
                                    }
                                }
                            }).finally(() => {
                                // 操作完confirm更新表单页面
                                this.getList();
                            }).catch(() => {});
                            return;
                        }
                        const dispatchNo = res.data.indexOf(',') < 0 ? res.data : res.data.split(',')[0];
                        showCopiableMessage(this.$message, `已保存，生成发车单号：${res.data}`, dispatchNo);
                        this.getList();
                        this.isArrangeSubmitVisi = false;
                    } else if (+res.code === 200) {
                        this.isArrangeSubmitVisi = false;
                        this.$message.error(res.msg || '');
                    }
                }).catch(() => {
                    this.isArrangeSubmitVisi = true;
                    this.$refs.carScheduling.saveLoading = false;
                });
            }
        },
        // 查询配置的服务平台
        async getSiteCodeList () {
            const res = await api.getSiteCodeList({ userCode: this.user.userCode });
            if (res && +res.code === 0) {
                this.siteCodeList = res.data.siteCodeList || [];
                this.getLayerIdList();
            }
        },
        getLayerIdList () {
            api.getLayerIdListApi({ siteCodeList: this.siteCodeList }).then(res => {
                if (res && +res.code === 0) {
                    const option = [];
                    res.data.forEach(v => {
                        option.push({ 'value': v.id, 'label': v.preLayerName });
                    });
                    // 注意。这个顺序要跟配置的预设区域顺序一致
                    this.config.searchList.searchTxt[0].options = option;
                }
            });
        }
    },
    async mounted () {
        await this.getSiteCodeList();
    }
};
</script>
